import { HorizontalLineBase, type HorizontalLineBaseProps } from "@core/ui";

export type Props = HorizontalLineBaseProps;

/**
 * Styled horizontal line/divider component wrapping HorizontalLineBase.
 */
export function HorizontalLine({ className, ...props }: Props) {
  return (
    <HorizontalLineBase
      className={`h-[1px] border-b border-brand-300 w-full ${className || ""}`}
      data-testid="horizontal-line"
      {...props}
    />
  );
}

export default HorizontalLine;

